const config = {
	api: {
		idm: {
			baseUrl: 'https://idm.ax-semantics.com/v1/'
		},
		quest: {
			baseUrl: 'https://quest-api.ax-semantics.com/',
		},
	},
	auth: {
		clientID: 'bufw8P1GSHgOO5g1QVn7U3hq2HoZJSHW',
		domain: 'ax-semantics.eu.auth0.com'
	},
	cockpit: {
		baseUrl: 'https://cockpit.ax-semantics.com/',
	},
	translate: {
		baseUrl: 'https://translate.ax-semantics.com/',
	},
}

export default config
